module.exports = __webpack_public_path__ + "static/media/cS-3.c32ef004.jpg";